import { render, staticRenderFns } from "./userAssets.vue?vue&type=template&id=b20d1a3c&"
import script from "./userAssets.vue?vue&type=script&lang=js&"
export * from "./userAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports